import request from '@/utils/request';

//const apiURL = process.env.VUE_APP_API_URL;
const apiURL =
    process.env.NODE_ENV === 'production' ? `${window.location.protocol}//${window.location.hostname}:${window.location.port}` : process.env.VUE_APP_API_URL;

export const login = params => {
    return request('post', `${apiURL}/fed45540-1a26-4ea3-a81c-3cdebc700c8d`, params);
};

export const towFAVerify = params => {
    return request('post', `${apiURL}/2FAVerify`, params);
};
